module.exports = __webpack_public_path__ + "img/unknown-user2.60acb02f.jpg";